// extracted by mini-css-extract-plugin
export default {"benefits":"KvZKf","title":"FmHSY","odd":"gcVNK","even":"Z_aut","grid":"e0sIL","imageContainer":"g4NQA","image":"HHaCe","text":"B64N5"};